<template>
  <div>
    <v-card>
      <v-card-title>Need a custom form?</v-card-title>
      <v-card-subtitle>
        While both Google and AirTable among other provide great solutions for
        basic forms, to really make something your own you need to build it
        custom. Keeping everything on brand is key to a sleek, engaging user
        experience. You'd hate to have spent all this time building your amazing
        website only to have to use a Google Form and lose all your custom
        branding.
      </v-card-subtitle>
      <v-row class="px-3 py-3">
        <v-col>
          <v-card>
            <v-card-title>Control</v-card-title>
            <v-card-subtitle>
              With a custom form you control exactly what data you collect, how
              you collect it and how it gets formatted for your internal use.
              You can implement exactly the privacy, validation and user flow
              you want.
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <v-card-title>Flexibility</v-card-title>
            <v-card-subtitle>
              Cookie-cutter solutions are great for getting started. But if
              you've ever tried to do anything that's even slightly out of the
              ordinary and you run into issue after issue. With a custom form
              you have the flexibility to do anything you need to.
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <h2 class="px-4 py-2">FAQ</h2>
      <v-expansion-panels flat tile>
        <v-expansion-panel>
          <v-expansion-panel-header class="heading">
            How much will it cost?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="text--secondary">
            Custom forms can be surprisingly affordable for something very
            basic, and you get plenty of features. Of course all pricing is
            dependent on the complexity of the work. Get in touch with us today
            and we can discuss your individual needs
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "FormsService",
  data: () => ({}),
};
</script>

<style></style>
